// extracted by mini-css-extract-plugin
module.exports = {"trustedRetailerBanner":"hg-z","trustedRetailerTooltipWrapper":"ig-z"};